import { engineFieldAttributes } from './fields/engine-field-attributes.js';
import { TextInput } from '@adornis/formfield/fields/text-input.js';
import { showDialog } from '@adornis/dialog/dialog-functions.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';
import { confirmSBInRegistrationForm } from '../api/confirmSBInRegistrationForm.js';

const AddGuardian = stateful((props: { schoolID: string; close: (value: string | null | undefined) => void }) => {
  const [existing, setExisting] = useState(false);
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  return html`<div class="flex flex-col gap-5 p-4 sm:p-6">
    <header class="flex items-start justify-between gap-3">
      <h2 class="font-semibold md:text-lg">Sorgeberechtigte Person hinzufügen</h2>
      <button
        type="button"
        class="btn btn-ghost btn-square shrink-0"
        aria-label="Dialog schließen"
        ?disabled=${sending}
        @click=${() => props.close(undefined)}
      >
        <span class="icon-[material-symbols--close-rounded] text-xl" aria-hidden="true"></span>
      </button>
    </header>
    ${
      existing
        ? html`<p>
              Die Person erhält eine E-Mail und bestätigt, dass ihre vorhandenen Daten für diese Bewerbung verwendet
              werden dürfen.
            </p>
            <form
              class="flex flex-col gap-4"
              @submit=${async (e: SubmitEvent) => {
                e.preventDefault();
                if (sending) return;
                setSending(true);
                setError('');
                try {
                  const submittedEmail = String(
                    new FormData(e.currentTarget as HTMLFormElement).get('email') ?? '',
                  ).trim();
                  const trackerID = await confirmSBInRegistrationForm(submittedEmail, props.schoolID)();
                  props.close(trackerID);
                } catch (e) {
                  setError(e instanceof Error ? e.message : 'Die Einladung konnte nicht gesendet werden.');
                } finally {
                  setSending(false);
                }
              }}
            >
              <div
                class="flex flex-col gap-2 [&_input]:text-base"
                ${engineFieldAttributes({ id: 'sus-guardian-email', name: 'email', label: 'E-Mail-Adresse', required: true })}
              >
                <label class="text-sm font-semibold text-base-content/70" for="sus-guardian-email"
                  >E-Mail-Adresse *</label
                >
                ${TextInput({ ariaLabel: 'E-Mail-Adresse', type: 'email', autocomplete: 'email', value: email, disabled: sending, onPicked: value => setEmail(value ?? '') })}
              </div>
              ${error ? html`<p class="alert alert-error alert-soft text-base-content" role="alert">${error}</p>` : nothing}
              <button type="submit" class="btn btn-primary w-full" ?disabled=${sending}>
                ${sending ? 'Wird gesendet …' : 'Bestätigungslink senden'}</button
              ><button
                type="button"
                class="btn btn-ghost w-full"
                ?disabled=${sending}
                @click=${() => setExisting(false)}
              >
                Zurück
              </button>
            </form>`
        : html`<p>Besitzt die Person bereits einen Zugang bei der Martinus-SG?</p>
            <button
              type="button"
              class="btn btn-primary h-auto min-h-11 whitespace-normal"
              @click=${() => setExisting(true)}
            >
              Ja, vorhandene Daten anfragen</button
            ><button
              type="button"
              class="btn btn-outline h-auto min-h-11 whitespace-normal"
              @click=${() => props.close(null)}
            >
              Nein, Daten selbst eintragen
            </button>`
    }
  </div>`;
});
export async function handleNewSb(schoolID: string): Promise<string | null | undefined> {
  return showDialog<string | null | undefined>({
    modalBoxClasses: 'w-full max-w-xl max-h-[calc(100dvh-1rem)]',
    content: ok => AddGuardian({ schoolID, close: ok }),
  }).catch(() => undefined);
}
